export function isFunction(func) {
    return (typeof func === 'function' && ['[object Function]', '[object AsyncFunction]', '[object GeneratorFunction]'].includes(Object.prototype.toString.call(func)));
}
